import { AxiosResponse } from 'axios';

import { getProgramDetailsUrl, getVodDetailsUrl } from 'config/api';

import {
    DETAILS_DATA_TYPES,
    getChannelIdFilter,
    getEpgProgramsPeriodFilter,
} from 'store/details/utils/constants';
import {
    BTVProgrammesResponse,
    ResponseError,
    VodResponse,
} from 'store/railsBuilder/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

import { DETAILS_PARAMS_TO_REQUEST_PARAMS } from 'screens/Detail/types';

function requestNoSeasonEpisodesData(
    type: DETAILS_DATA_TYPES,
    seriesId: string,
    channelId?: string | undefined,
    page?: number,
    limit?: number,
):
    | Promise<
          AxiosResponse<BTVProgrammesResponse | VodResponse | ResponseError>
      >
    | undefined {
    if (type === DETAILS_DATA_TYPES.VOD) {
        return NagraInstance.get(
            getVodDetailsUrl({
                filter: JSON.stringify({
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.seriesId]: seriesId,
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialSeasonNumber]: {
                        $exists: false,
                    },
                }),
                page,
                limit,
            }),
        );
    }

    if (type === DETAILS_DATA_TYPES.PROGRAM) {
        return NagraInstance.get(
            getProgramDetailsUrl({
                filter: JSON.stringify({
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.seriesId]: seriesId,
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialSeasonNumber]: {
                        $exists: false,
                    },
                    ...getChannelIdFilter(channelId),
                    ...getEpgProgramsPeriodFilter(),
                }),
                page,
                limit,
            }),
        );
    }

    return undefined;
}

export default requestNoSeasonEpisodesData;
